import { z } from "zod";

/**
 * Service-providers shared contract (Strangler-Fig migration, manifest-6 / A10).
 *
 * Single source of truth for the `service_providers` wire shape shared by the
 * web SPA (`src/repositories/serviceProviders.ts`) and the NestJS slice
 * (`apps/api/src/service-providers/*`). Shape is **snake_case** so the
 * frontend<->Nest transport is a field-for-field swap (no renames), matching
 * the Supabase generated Row and the Nest repository `.select()`.
 *
 * The web repo `.parse()`s Nest responses at the staff flip boundary.
 * Contains all columns of the `service_providers` table (no relation joins).
 */
export const serviceProviderSchema = z
  .object({
    id: z.string(),
    company_id: z.string(),
    name: z.string(),
    name_en: z.string().nullable(),
    specialty: z.string(),
    // Nafath identity (mirrors owners): set at invite-accept, hard-gated by the RPC.
    national_id: z.string().nullable().optional(),
    // toWire always emits a boolean (defaults false) — never null.
    nafath_verified: z.boolean().optional(),
    nafath_verified_at: z.string().nullable().optional(),
    phone: z.string().nullable(),
    email: z.string().nullable(),
    address: z.string().nullable(),
    notes: z.string().nullable(),
    is_active: z.boolean().nullable(),
    rating: z.number().nullable(),
    total_jobs: z.number().nullable(),
    invitation_status: z.string(),
    deleted_at: z.string().nullable(),
    created_at: z.string(),
    updated_at: z.string(),
  })
  .passthrough();

export type ServiceProvider = z.infer<typeof serviceProviderSchema>;
